var map = {
	"./course/en": "OePH",
	"./course/en.js": "OePH",
	"./course/zh-CN": "+heH",
	"./course/zh-CN.js": "+heH",
	"./customer/en": "sjgW",
	"./customer/en.js": "sjgW",
	"./customer/zh-CN": "DOuD",
	"./customer/zh-CN.js": "DOuD",
	"./device/en": "1E2w",
	"./device/en.js": "1E2w",
	"./device/zh-CN": "OqKu",
	"./device/zh-CN.js": "OqKu",
	"./dict/en": "wTSh",
	"./dict/en.js": "wTSh",
	"./dict/zh-CN": "v5nZ",
	"./dict/zh-CN.js": "v5nZ",
	"./earlyWarningManager/en": "4UxW",
	"./earlyWarningManager/en.js": "4UxW",
	"./earlyWarningManager/zh-CN": "hmcP",
	"./earlyWarningManager/zh-CN.js": "hmcP",
	"./en": "5SxN",
	"./en.js": "5SxN",
	"./factor/en": "11Ge",
	"./factor/en.js": "11Ge",
	"./factor/zh-CN": "BBRl",
	"./factor/zh-CN.js": "BBRl",
	"./interfaceToast-en": "Yl7d",
	"./interfaceToast-en.js": "Yl7d",
	"./interfaceToast-zh-CN": "z9Ss",
	"./interfaceToast-zh-CN.js": "z9Ss",
	"./log/en": "3619",
	"./log/en.js": "3619",
	"./log/zh-CN": "yp8Y",
	"./log/zh-CN.js": "yp8Y",
	"./login/en": "nRpd",
	"./login/en.js": "nRpd",
	"./login/zh-CN": "BWkq",
	"./login/zh-CN.js": "BWkq",
	"./menuManager/en": "uv1t",
	"./menuManager/en.js": "uv1t",
	"./menuManager/zh-CN": "Efyx",
	"./menuManager/zh-CN.js": "Efyx",
	"./newsAndInformation/en": "Tz1E",
	"./newsAndInformation/en.js": "Tz1E",
	"./newsAndInformation/zh-CN": "x8XW",
	"./newsAndInformation/zh-CN.js": "x8XW",
	"./notification/en": "+vpu",
	"./notification/en.js": "+vpu",
	"./notification/zh-CN": "0vJP",
	"./notification/zh-CN.js": "0vJP",
	"./opsMap/en": "Z9wS",
	"./opsMap/en.js": "Z9wS",
	"./opsMap/zh-CN": "iebB",
	"./opsMap/zh-CN.js": "iebB",
	"./orderManager/en": "b6gu",
	"./orderManager/en.js": "b6gu",
	"./orderManager/zh-CN": "mQhx",
	"./orderManager/zh-CN.js": "mQhx",
	"./personnelManager/en": "0owL",
	"./personnelManager/en.js": "0owL",
	"./personnelManager/zh-CN": "L3wi",
	"./personnelManager/zh-CN.js": "L3wi",
	"./psychologicalHotline/en": "LJxG",
	"./psychologicalHotline/en.js": "LJxG",
	"./psychologicalHotline/zh-CN": "/+at",
	"./psychologicalHotline/zh-CN.js": "/+at",
	"./roleManager/en": "gq2V",
	"./roleManager/en.js": "gq2V",
	"./roleManager/zh-CN": "iopd",
	"./roleManager/zh-CN.js": "iopd",
	"./scaleTemplate/en": "7aMc",
	"./scaleTemplate/en.js": "7aMc",
	"./scaleTemplate/zh-CN": "D4+R",
	"./scaleTemplate/zh-CN.js": "D4+R",
	"./scaleTypeTemplate/en": "+9qL",
	"./scaleTypeTemplate/en.js": "+9qL",
	"./scaleTypeTemplate/zh-CN": "jvP3",
	"./scaleTypeTemplate/zh-CN.js": "jvP3",
	"./tenantManager/en": "BUvp",
	"./tenantManager/en.js": "BUvp",
	"./tenantManager/zh-CN": "2fz5",
	"./tenantManager/zh-CN.js": "2fz5",
	"./zh-CN": "iW45",
	"./zh-CN.js": "iW45"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LEGu";


//////////////////
// WEBPACK FOOTER
// ./src/i18n ^\.\/.*$
// module id = LEGu
// module chunks = 44